module.exports = __webpack_public_path__ + "img/sumo.d36c9abd.svg";